exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#showtime{font-weight:700}.badge.badge-circle{border-radius:100%;width:33px;height:33px;font-size:16px;font-weight:400;line-height:1.7;padding:4px 5px;vertical-align:baseline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-8dc9e1fa","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/school/LMS/examForm.vue
// module id = 141
// module chunks = 0